import {InjectionToken} from '@angular/core';
import {MxAssignmentGrid} from './mx-assignment-grid';


export interface MxAssignmentComponentsService {
    getComponent(componentName: string): new () => MxAssignmentGrid;
}

export const MX_ASSIGNMENT_COMPONENTS_SERVICE_TOKEN =
    new InjectionToken<MxAssignmentComponentsService>('MX_ASSIGNMENT_COMPONENTS_SERVICE_TOKEN');
